import React, { useState, useEffect } from 'react';
import Layout from '../shared/Layout';

// Componentes locales de preadmision_curso
import HistorialAcademicoAdmision from './HistorialAcademicoAdmision';
import AsignaturasPreadmision from './AsignaturasPreadmision';
import CursosExtensionPreadmision from './CursosExtensionPreadmision';

const DashboardPreadmisionCurso = ({ onLogout }) => {
    const [activeMenu, setActiveMenu] = useState('asignaturas');
    const [userInfo, setUserInfo] = useState({ userName: '', userRole: '' });

    // Menús para preadmision_curso - Orden: Inscripción Asignaturas, Historial Académico
    const menuItems = [
        { id: 'asignaturas', label: 'Inscripción Asignaturas' },
        { id: 'historial', label: 'Historial Académico' }
    ];

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        setUserInfo({
            userName: user.nombre_completo || user.username || 'Usuario',
            userRole: 'Estudiante - Preadmisión'
        });
    }, []);

    const renderContent = () => {
        switch (activeMenu) {
            case 'historial':
                return <HistorialAcademicoAdmision />;
            case 'asignaturas':
                return <AsignaturasPreadmision />;
            case 'cursos-extension':
                return <CursosExtensionPreadmision />;
            default:
                return <HistorialAcademicoAdmision />;
        }
    };

    return (
        <Layout
            userName={userInfo.userName}
            userRole={userInfo.userRole}
            menuItems={menuItems}
            onLogout={onLogout}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
        >
            {renderContent()}
        </Layout>
    );
};

export default DashboardPreadmisionCurso;
